<template>
  <v-container fill-height>
    <v-layout>
      <v-flex>
        <v-card class="forgot-password mb-8" outlined>
          <v-app-bar dark color="primary">
            <h3>{{ $t('passwordResetScreen.title') }}</h3>
          </v-app-bar>
          <ValidationObserver ref="forgotPasswordForm">
            <v-form @submit.prevent="onSubmit">
              <v-card-text class="pt-8 px-6">
                <p class="description">
                  {{ $t('passwordResetScreen.description') }}
                </p>
                <ValidationProvider
                  ref="email"
                  name="email"
                  vid="email"
                  rules="required|email"
                  slim
                >
                  <v-text-field
                    name="email"
                    v-model="email"
                    type="email"
                    :label="$t('passwordResetScreen.emailPlaceholder')"
                    prepend-icon="person"
                  />
                </ValidationProvider>
              </v-card-text>
              <v-card-actions class="mb-5">
                <v-spacer></v-spacer>
                <v-btn
                  type="submit"
                  color="primary"
                  :loading="loading"
                  :disabled="loading"
                >
                  {{ $t('passwordResetScreen.buttonText') }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showDialog" max-width="340px" persistent>
      <v-card>
        <v-card-title>
          <h3>{{ dialogTitle }}</h3>
        </v-card-title>
        <v-card-text>
          <p>{{ dialogMessage }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAction"
          >
            {{ $t('passwordResetScreen.confirmButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  data() {
    return {
      email: '',
      loading: false,
      showDialog: false,
      dialogTitle: '',
      dialogMessage: '',
      dialogAction: () => {}
    }
  },
  methods: {
    ...mapActions(['requestResetPassword']),
    onSubmit() {
      this.$refs.forgotPasswordForm.validate().then((success) => {
        if (success) {
          this.submitRequest()
        } else {
          this.openDialog(
            this.$t(
              'passwordResetScreen.noValidEmailErrorTitle'
            ),
            this.$t(
              'passwordResetScreen.noValidEmailErrorMessage'
            ),
            this.closeDialog
          )
        }
      })
    },
    async submitRequest() {
      this.loading = true

      try {
        const response = await this.requestResetPassword(this.email)
        this.loading = false

        if (response.code === 'NO_EMAIL_FOUND') {
          this.openDialog(
            this.$t(
              'passwordResetScreen.noEmailFoundErrorTitle'
            ),
            this.$t(
              'passwordResetScreen.noEmailFoundErrorMessage'
            ),
            this.closeDialog
          )
        } else {
          this.openDialog(
            this.$t(
              'passwordResetScreen.successTitle'
            ),
            this.$t(
              'passwordResetScreen.successMessage',
              {
                mail: this.email
              }
            ),
            this.finishProcess
          )
        }
      } catch (error) {
        this.loading = false
        this.openDialog(
          this.$t(
            'passwordResetScreen.errorTitle'
          ),
          this.$t(
            'passwordResetScreen.errorMessage'
          ),
          this.closeDialog
        )
      }
    },
    openDialog(title, message, action) {
      this.dialogTitle = title
      this.dialogMessage = message
      this.showDialog = true
      this.dialogAction = action
    },
    closeDialog() {
      this.showDialog = false
      this.dialogTitle = ''
      this.dialogMessage = ''
      this.dialogAction = () => {}
    },
    finishProcess() {
      this.closeDialog()
      this.$router.push({name: 'signin'})
    }
  },
}
</script>

<style lang="scss" scoped>
.forgot-password {
  max-width: 560px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
}

.description {
  color: var(--secondary-text-color, #818181);
}
</style>
